import { useContext } from 'react';

import { ClientFilterContext } from '../context';

const useClientFilters = () => {
  const context = useContext(ClientFilterContext);

  if (!context) {
    throw new Error('useClientFilters must be used within a ClientFilterProvider');
  }

  return context;
};

export default useClientFilters;
